// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"b95873e4","409":"1104ef32","689":"5fe67c5d","849":"4113a75b"}[chunkId] + ".chunk.js";
};